/**
 * Ask Document Question Action
 * 
 * Submits a question about a user's processed documents to the document chat system.
 * This is a premium feature - requires documentChat claim.
 */

import axiosInstance from '../utils/axiosInstance';

export interface AskDocumentQuestionRequest {
  question: string;
  sourceJobId: string;  // The job whose documents we're querying
}

export interface AskDocumentQuestionResponse {
  jobId: string;        // The chat job ID for tracking
  chatId: string;       // Unique ID for this chat message
  sourceJobId: string;  // Echo back the source job
  message: string;      // Status message
}

/**
 * Submit a question about user's processed documents
 * 
 * @param request - The question and source job ID
 * @returns Job tracking information for Pusher updates
 */
export async function askDocumentQuestion(
  request: AskDocumentQuestionRequest
): Promise<AskDocumentQuestionResponse> {
  console.log('[Action] askDocumentQuestion called with:', {
    questionLength: request.question?.length,
    sourceJobId: request.sourceJobId,
  });

  const response = await axiosInstance.post<AskDocumentQuestionResponse>(
    `/jobs/${request.sourceJobId}/chat`,
    { question: request.question }
  );

  console.log('[Action] askDocumentQuestion received response:', {
    jobId: response.data.jobId,
    chatId: response.data.chatId,
    sourceJobId: response.data.sourceJobId,
  });

  return response.data;
}

